module.exports = __webpack_public_path__ + "img/logout.610aa4c5.svg";